import React, {useEffect, useRef} from 'react';
import Typograf from 'typograf';

import { request } from '../../../api';

const VtrgSplitScreen = ({data, slot, instanceType, instanceId, pieceType}) => {
  const tp = new Typograf({ locale: ["ru", "en-US"] });

  let lStyle = {}
  const leftBlock = useRef();
  const rightBlock = useRef();
  
  
  if(data.lback)    { lStyle.backgroundColor = data.lback }
  if(data.lpadding) { lStyle.padding = data.lpadding }
  if(data.lmargin)  { lStyle.padding = data.lmargin }
  const lStringStyle = (data.lfree_style) ? data.lfree_style : '';
  
  const lPartContent = data && data.limage && data.limage.url  ?
          (<div className="part-img">
            <img src={`${request}${data.limage.url}`} />
          </div>) :
          (
            <div className="holder">
              <div className="content" dangerouslySetInnerHTML={{__html: tp.execute(data && data.lbody ? data.lbody : '') }}></div>
            </div>
          )

  let rStyle = {}
  if(data.rback) { rStyle.backgroundColor = data.rback }
  if(data.rpadding) { rStyle.padding = data.rpadding }
  if(data.rmargin) { rStyle.padding = data.rmargin }
  const rStringStyle = (data.rfree_style) ? data.rfree_style : '';

  const rPartContent = data && data.rimage && data.rimage.url  ?
    (<div className="part-img">
      <img src={`${request}${data.rimage.url}`} />
    </div>) :
    (
      <div className="holder">
        <div className="content" dangerouslySetInnerHTML={{__html: tp.execute(data && data.rbody ? data.rbody : '') }}></div>
      </div>
    )
    
   useEffect(() => {
    if ( leftBlock.current && lStringStyle)  { leftBlock.current.setAttribute('style', lStringStyle) };
    if ( rightBlock.current && rStringStyle)  { rightBlock.current.setAttribute('style', rStringStyle) };
   },[leftBlock, rightBlock, lStyle, rStyle]);

  
  return(
    <div className="cb-split-screen" data-slot={slot}>
      <div className="split-part"  ref={leftBlock} style={lStyle}>
        <div className="part-holder"> {lPartContent} </div>
      </div>
      <div className="split-part" ref={rightBlock} style={rStyle}>
        <div className="part-holder"> {rPartContent} </div>
      </div>
    </div>
  );
}

export default VtrgSplitScreen;
